import { useEffect,useState,useRef } from 'react';

export default function AdverCard ({s,indx}){
    const colorMap = {
        gradient: `from-red-500 to-red-700`,
      };

   
      const adverColor=[
        "from-[#ff6b6b] to-[#ffa500]",
        "from-[#4facfe] to-[#00f2fe]",
      ]

      const ref = useRef();
      const [isVisible, setIsVisible] = useState(false);
    
      useEffect(() => {
        const observer = new IntersectionObserver(

    
            ([entry]) => {if (!isVisible && entry.isIntersecting) {
              setIsVisible(true);
            }
            },
          
            {
              threshold: 0.2, 
            }
          
        
        );
    
        if (ref.current) {

          observer.observe(ref.current);
        }
    
        return () => {
          if (ref.current) observer.unobserve(ref.current);
        };
      }, []);
    
    return(

        <>
            {indx % 2 === 0 ? (
                <div
                    ref={ref}
                    className={`col-span-full h-[180px] overflow-y-scroll flex flex-col justify-center 
            rounded-2xl p-6 text-white relative shadow-lg transform hover:scale-[1.02] 
            transition-all duration-400 delay-100 
            ${
                        isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-8"
                    } bg-[linear-gradient(135deg,#ff6b6b_0%,#ffa500_100%)]`}
                >
                    <div className="absolute top-3 right-3 bg-black/20 px-2 py-1 rounded text-xs font-semibold">
                        ads
                    </div>
                    <div className="relative z-10 flex flex-row w-full items-center justify-between py-1 md:mt-0">
                        <div className="basis-2/3 overflow-x-hidden">
                            <h3 className="text-lg font-bold mb-1 max-w-full whitespace-normal break-words">
                                🚀 {s.title}
                            </h3>
                            <p className="text-sm opacity-90 whitespace-normal break-words">
                                {s.body} this widget is for sale and others for traders in USA
                            </p>
                            <div className="flex items-center space-x-2 mt-2">
                <span className="bg-white/20 px-2 py-1 rounded text-xs font-semibold">
                  Limited Time
                </span>
                                <span className="text-xs font-bold">50% OFF</span>
                            </div>
                        </div>
                        <div className="text-right basis-1/3 mt-2">
                            <div className="text-2xl font-bold">FREE</div>
                            <div className="text-xs opacity-80 line-through">$58</div>
                            <button className="bg-white/20 hover:bg-white/30 px-2 py-2 rounded-lg text-sm mt-6 transition-colors font-bold text-center truncate w-[120px] h-[40px] whitespace-normal break-words">
                                {/*{s.link}*/} upgarde now
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    ref={ref}
                    id="ad-banner-2"
                    className={`col-span-2 h-[180px] rounded-2xl p-6 text-white relative overflow-hidden cursor-pointer shadow-lg transform hover:scale-[1.02] transition-all duration-300 
            ${
                        isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-8"
                    } bg-[linear-gradient(135deg,#4facfe_0%,#00f2fe_100%)]`}
                >
                    <div className="absolute top-3 right-3 bg-black/20 px-2 py-1 rounded text-xs font-medium">
                        ads
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent rounded-2xl"></div>
                    <div className="absolute inset-0 overflow-hidden rounded-2xl">
                        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/10 to-transparent"></div>
                    </div>
                    <div className="relative z-10 flex items-center justify-between">
                        <div>
                            <h3 className="text-lg font-bold mb-1">📈 Advanced Analytics</h3>
                            <p className="text-sm opacity-90">
                                Real-time market analysis and insights
                            </p>
                            <div className="flex items-center space-x-2 mt-2">
                <span className="bg-white/20 px-2 py-1 rounded text-xs font-medium">
                  Pro Features
                </span>
                                <span className="text-xs">Free Trial</span>
                            </div>
                        </div>
                        <div className="text-right pt-6">
                            <div className="text-2xl font-bold">FREE</div>
                            <div className="text-xs opacity-80">7 Days Trial</div>
                            <button className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg text-sm font-medium mt-2 transition-colors">
                                Start Now
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
      //   <div ref={ref} className={`col-span-full h-[180px] overflow-y-scroll flex flex-col justify-center rounded-2xl p-6 text-white relative shadow-lg transform hover:scale-[1.02] transition-all duration-400 delay-100 ${
      //       isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      //   } bg-[linear-gradient(135deg,#ff6b6b_0%,#ffa500_100%)]`}>
      //       <div className="absolute top-3 right-3 bg-black/20 px-2 py-1 rounded text-xs font-semibold">ads</div>
      //       <div className="relative z-10 flex flex-row w-full items-center justify-between py-1 md:mt-0 ">
      //           <div className="basis-2/3 overflow-x-hidden">
      //               <h3 className="text-lg font-bold mb-1 max-w-full whitespace-normal break-words   ">🚀 {s.title}</h3>
      //               <p className="text-sm opacity-90 whitespace-normal break-words ">{s.body} this widget is for sale and others for traders in USA</p>
      //               <div className="flex items-center space-x-2 mt-2 ">
      //               <span className="bg-white/20 px-2 py-1 rounded text-xs font-semibold">Limited Time</span>
      //               <span className="text-xs font-bold">50% OFF</span>
      //               </div>
      //           </div>
      //           <div className="text-right basis-1/3 mt-2">
      //               <div className="text-2xl font-bold">FREE</div>
      //               <div className="text-xs opacity-80 line-through">$58</div>
      //               <button className="bg-white/20 hover:bg-white/30 px-2 py-2 rounded-lg text-sm mt-2 transition-colors font-bold text-cneter truncate w-[80px] h-[60px] whitespace-normal break-words ">{s.link}</button>
      //           </div>
      //       </div>
      // </div>
    )
}